import { SessionStorage } from "./sessionStorage";

class AppTokenStorage extends SessionStorage {
	public constructor() {
		super({
			storageKey: "app_token",
		});
	}
}

export const appTokenStorage = new AppTokenStorage();
